const ADDRESS_FIELDS_PER_SET = 4;

export default class AddressAutofill {
    constructor() {
        this.addressElements = document.querySelectorAll(
            "input.js-adressautofill"
        );

        if (!this.addressElements.length) {
            console.warn("No address elements found on the page.");
            return;
        } else {
            this.init();
        }
    }

    init() {
        this.disableTargetInputs(this.addressElements);

        this.groupElementsIntoSets().forEach((addressSet, index) => {
            const autofillInstance = new Autofill(
                addressSet,
                this.enableTargetInputs.bind(this, addressSet)
            );
        });
    }

    disableTargetInputs(elements) {
        elements.forEach((input) => {
            if (!input.classList.contains("js-adressautofill-input")) {
                input.readOnly = true;
            }
        });
    }

    enableTargetInputs(elements) {
        elements.forEach((input) => {
            if (!input.classList.contains("js-adressautofill-input")) {
                input.readOnly = false;
                input.value = "";
            }
        });
    }

    groupElementsIntoSets() {
        const addressSets = [];
        for (
            let i = 0;
            i < this.addressElements.length;
            i += ADDRESS_FIELDS_PER_SET
        ) {
            const addressSet = Array.from(this.addressElements).slice(
                i,
                i + ADDRESS_FIELDS_PER_SET
            );
            addressSets.push(addressSet);
        }
        return addressSets;
    }
}

class Autofill {
    constructor(elements, enableCallback) {
        this.elements = elements;
        this.enableCallback = enableCallback;
        this.debouncedCheckAndFetch = this.debounce(
            this.checkAndFetch.bind(this),
            500
        );

        this.addInputListeners();
    }

    addInputListeners() {
        const inputValues = {};

        this.elements.forEach((input) => {
            if (input.classList.contains("js-adressautofill-input")) {
                input.addEventListener("input", () => {
                    inputValues[input.name] = input.value.trim();
                    this.debouncedCheckAndFetch(inputValues);
                });
            }
        });
    }

    checkAndFetch() {
        const inputValues = this.elements
            .filter((input) =>
                input.classList.contains("js-adressautofill-input")
            )
            .map((input) => input.value.trim());

        if (
            inputValues.length === 2 &&
            inputValues.every((value) => value !== "")
        ) {
            this.fetchAddressDetails(inputValues[0], inputValues[1]);
        }
    }

    debounce(func, delay) {
        let timeoutId;

        return function (...args) {
            clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    fetchAddressDetails(postalCode, houseNumber) {
        const fetchUrl = `/apis/sixpp/${postalCode}/${houseNumber}`;

        fetch(fetchUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        `Failed to fetch address details. Status: ${response.status}`
                    );
                }
                return response.json();
            })
            .then((data) => {
                const { street, city } = data;
                this.updateTargetInputs(street, city);
            })
            .catch((error) => {
                console.error("Error fetching address details:", error);
                this.enableCallback();
            });
    }

    updateTargetInputs(street, city) {
        this.elements.forEach((input) => {
            if (input.classList.contains("js-adressautofill-target--street")) {
                input.value = street;
                input.readOnly = true;
            } else if (
                input.classList.contains("js-adressautofill-target--city")
            ) {
                input.value = city;
                input.readOnly = true;
            }
        });
    }
}
